import { nanoid } from "nanoid";

export default function getUUID() {
  return nanoid();
}
